module.exports = __webpack_public_path__ + "img/z4.276e268e.png";